import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=5bca7513"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bca7513')) {
      api.createRecord('5bca7513', component.options)
    } else {
      api.reload('5bca7513', component.options)
    }
    module.hot.accept("./Payment.vue?vue&type=template&id=5bca7513", function () {
      api.rerender('5bca7513', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Payment.vue"
export default component.exports